export enum InstanceIds {
  /** JR-INT Slot */
  JR_INT = '6d226c03f32a8ea4e8ae8e5cbe6c6e2c',
  /** Slot 66 for Time Tracking */
  TIME_TRACKING_TEST = 'a9fd898a9789442aa51cae6e0df0d735',
  /** Slot 173 DXP main development */
  DXP_DEV = 'dca04b22cc05c56ff0aee1dcb792e456',
  /** No slot Standalone instance */
  STANDALONE = '8fa4cea934b2ebddddb18ec27957bed1',
  /** Slot 112 for sync test */
  SYNC_TEST = '8ffe219fcae0cf56118fbaaebee89086',
  /** Slot 130 QST Builder & Automations forms */
  QST_BUILDER_TEST = '9186b8d3584704729b37dbe37349cca3',
}
